import { AbacoWebModule, ApplicationReadyEvent } from "@abaco/web-common/src/app";
import BigDataGrapesWidgetAPI from './api/BigDataGrapesWidgetAPI';
import globals from "./globals";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import DashboardChartsModule from "@abaco/dashboard-module/src/modules/charts/index";
import SSOModule from '@abaco/sso-web-module/src/abaco-module';
import FarmerRegistryModule from "@abaco/farm-registry/src/modules/farm-registry";
import GlobalStateModule from "@abaco/portal-global-state/src/modules/global-state";

export const MODULE_ID = "big_data_grapes_widgets_module";

export default class BigDataGrapesWidgetModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;

    private nwApi!: BigDataGrapesWidgetAPI;
    private apiCreated!: boolean;
    private ssoModule!: SSOModule;

    dependsOn = {
        [GlobalStateModule.MODULE_ID]: () => new GlobalStateModule(),
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
    }

    async onApplicationReady(evt: ApplicationReadyEvent) {
        this.ssoModule = evt.modules.find((m) => m.id === SSOModule.MODULE_ID) as SSOModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const useSensorX = await this.useSensorX(http);

        let newHttp = http;
        const path = useSensorX ? 'sensor-x/api' : 'sensor-proxy'
        if (!useSensorX) {
            newHttp = new HTTPClient();
            this.ssoModule.addAnauthorizedHandler(newHttp);
            newHttp.addRequestConfigProvider(async config => {
                config.params = config.params || {};
                config.params["SSO_TOKEN"] = await this.ssoModule.getSSOToken();
            })
        }

        const BigDataGrapesWidgetAPI = (await import("./api/BigDataGrapesWidgetAPI")).default;
        this.nwApi = new BigDataGrapesWidgetAPI(http, newHttp, path);
    }

    public get BigDataGrapesWidgetAPI() {
        return this.nwApi;
    }

    private async useSensorX(http: HTTPClient): Promise<boolean> {
        const url = "/siticatasto/dbgis-servlet/tl_data?svccode=portal/get_gisparams";
        const params = {
            variable: "SENSORX_SERVER_URL_EXTERNAL"
        }
        const res = await http.get(url, { params });
        return res.data.services[0].entities.length > 0;
    }
}
